import URL from '../legacy/common/URL'

export const isBarona = (): boolean => {
    return URL.getCurrent().includes('barona')
}
